import "./HealthNotice.scss";

export function HealthNotice() {
  return <p className="health-notice">Informațiile din acest blog sunt furnizate strict în scop educațional, nu pentru a diagnostica sau trata orice stare de sănătate, și nu au intenția de a înlocui instrucțiunile unui practician de asistență medicală competent!</p>;
}
